import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    open: boolean;
    singleData: any;
    hideDialog: () => void;
    toast: any;
}

interface ILegalComments {
    id?: number,
    task_ID?: number,
    comment?: string,
    added_By?: string,
    added_On?: Date,
    added_By_ID?: number
}

interface ILegalComment {
    comment: string,
    task_ID: number,
}

const schema = yup.object({
    comment: yup.string().required("Comment is required*"),
    task_ID: yup.number().required(),
});


export const LegalTaskComments = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ILegalComments[], loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DataFormat = loginObj.date_Format;

    const { control, handleSubmit, formState: { errors }, setValue, reset } = useForm<ILegalComment>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Legal_Task/getTaskComment", "GET", null, `task_ID=${props.singleData.id}`, props.toast);
        if (response) {
            const data: Array<ILegalComments> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const onSubmit = async (data: ILegalComment) => {
        setLoading(true);
        const response = await Fetch("Legal_Task/addTaskComment", "POST", data, null, props.toast);
        if (response) {
            setLoading(false);
            reset({ comment: "", task_ID: props.singleData.id });
            loadTableData();
        } else setLoading(false);
    };

    const onHide = () => {
        setTableData({ tableData: [], loading: false });
        setLoading(false);
        reset({ comment: "", task_ID: 0 });
        props.hideDialog();
    };

    useEffect(() => {
        if (props.open && props.singleData.id) {
            setValue("task_ID", props.singleData.id);
            loadTableData();
        }
    }, [props.open])

    return (
        <Dialog visible={props.open} header="Task Comments" style={{ width: "35vw" }} modal onHide={onHide}>
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-1">
                    <JVInput required label="Comment" control={control} name="comment" error={errors.comment?.message} />
                    <div className="field col-12 md:col-3">
                        <label htmlFor="">&nbsp;</label>
                        <Button loading={loading} label="SUBMIT" type="submit"></Button>
                    </div>
                </form>
                <hr />
                <div className="mt-3"></div>
                <div style={{  height: "35vh", overflowY: "scroll", border: "1px solid #e9e9e9", padding: "2rem" }}>
                    {tableData.loading === true && <p>Loading...</p>}
                    {tableData.loading === false && tableData.tableData.map((el: ILegalComments) => {
                        const date = new Date(el.added_On || "");
                        const hours = date.getHours();
                        const ampm = hours >= 12 ? "P.M." : "A.M.";

                        const dateTime: string = String(new Date(el.added_On || "").getDate()).padStart(2, "0") + "/" +
                            String(new Date(el.added_On || "").getMonth() + 1).padStart(2, "0") + "/" +
                            new Date(el.added_On || "").getFullYear() + " " +
                            String(new Date(el.added_On || "").getHours()).padStart(2, "0") + ":" +
                            String(new Date(el.added_On || "").getMinutes()).padStart(2, "0") + ":" +
                            ampm;
                        if (el.added_By_ID === loginObj.id) {
                            return <div className="w-full flex justify-content-end">
                                <WhatsAppMessage name={""} message={el.comment || ""} dateAndtime={dateTime} />
                            </div>
                        } else return <div className="w-full flex justify-content-start">
                            <WhatsAppMessage name={el.added_By || ""} message={el.comment || ""} dateAndtime={dateTime} />
                        </div>;
                    })}
                </div>
            </Card>
        </Dialog>
    );
}

const WhatsAppMessage = (props: { name: string, message: string, dateAndtime: string }) => {
    return (
        <>
            <div
                style={{
                    marginTop: "1rem",
                    display: "inline-block",
                    maxWidth: "500px",
                    minWidth: "250px",
                    backgroundColor: "#e9e9e9",
                    borderRadius: "7px",
                    padding: "5px 8px 6px 8px",
                    color: "#e9edef",
                    fontFamily: "Arial, sans-serif",
                    boxShadow: "0 1px 1px rgba(0,0,0,0.2)",
                }}
            >
                {/* Sender Name */}
                <div
                    style={{
                        color: "#2291f9",
                        fontSize: "14px",
                        fontWeight: "600",
                        marginBottom: "4px",
                    }}
                >
                    {props.name}
                </div>

                {/* Message + Time */}
                <div
                    style={{
                        fontSize: "16px",
                        color: "#151719",
                        lineHeight: "21px",
                        position: "relative",
                        paddingRight: "50px",
                        wordBreak: "break-word",
                    }}
                >
                    {props.message}

                    {/* Time */}
                    <span
                        style={{
                            position: "absolute",
                            right: "0",
                            bottom: "-2px",
                            fontSize: "11px",
                            color: "#000000",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {props.dateAndtime}
                    </span>
                </div>
            </div>
        </>
    );
}